<template>
  <form novalidate class="grid gap-4 sm:max-w-[425px]" @submit.prevent="login">
    <div class="relative flex flex-col gap-2">
      <Label for="email" class="text-left"> Email </Label>
      <Input
        id="email"
        v-model="email"
        required
        type="email"
        name="email"
        placeholder="name@company.com"
        autocomplete
        @keydown="isDirty = true"
      />
      <ProseSmall
        v-if="requiredEmailError"
        class="absolute bottom-[-20px] left-0 text-red-500"
      >
        {{ $t("auth.email-required") }}
      </ProseSmall>

      <ProseSmall
        v-else-if="invalidEmailError"
        class="absolute bottom-[-20px] left-0 text-red-500"
      >
        {{ $t("auth.email-invalid") }}
      </ProseSmall>
    </div>

    <Button
      type="submit"
      variant="light"
      size="lg"
      :disabled="loading"
      class="w-full mt-4"
    >
      {{ $t("auth.sign-in") }}
    </Button>
  </form>
</template>

<script setup lang="ts">
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import ProseSmall from "../Typography/ProseSmall.vue";

const { signIn } = useAuth();
const { openVerifyRequestModal } = useModals();
const { t } = useI18n();

const email = ref("");
const loading = ref(false);
const isDirty = ref(false);
const invalidEmailError = ref(false);

const requiredEmailError = computed(() => {
  return isDirty.value && email.value.length === 0;
});

const isValidEmail = () => {
  return (
    email.value.length > 0 && email.value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
  );
};

watch(isValidEmail, (newValue) => {
  if (newValue) {
    invalidEmailError.value = false;
  }
});

const login = async () => {
  if (!isValidEmail()) {
    invalidEmailError.value = true;
    return;
  }

  loading.value = true;
  const result = await signIn("email", { email: email.value, redirect: false });

  if (result?.ok && result?.error === null) {
    openVerifyRequestModal();
  } else {
    create({
      title: t("auth.error"),
      text: t("auth.error-description"),
      type: "error",
    });
  }
  loading.value = false;
};
</script>
